import { useSelector } from 'react-redux'

import { useAppSelector } from 'app/state'

import { userAccountIsReady } from 'features/users/state/usersSlice'
import useAuthenticationError from './useAuthenticationError'

import { useIsAccountReady } from './useIsAccountReady'
import useAuthentication from './useAuthentication'
import { RequestStatus } from 'features/common'

export enum AuthenticationStatus {
  Loading,
  Success,
  Error,
  NotAuthenticated,
  Incomplete,
  AccountProvisioning
}

function useAuthenticationStatus() {
  const user = useAppSelector((state) => state.users.me)
  const isLoadingMeRequest = useAppSelector(
    (state) => state.users.meStatus !== RequestStatus.Fulfilled && state.users.meStatus !== RequestStatus.Rejected
  )
  const { isAuthenticated, isLoading } = useAuthentication()
  const hasError = useAuthenticationError()
  const { accountReady } = useIsAccountReady()
  const isAccountProvisioningReady = useSelector(userAccountIsReady)

  if (isLoading) {
    return AuthenticationStatus.Loading
  }

  if (hasError) {
    return AuthenticationStatus.Error
  }

  if (!isAuthenticated) {
    return AuthenticationStatus.NotAuthenticated
  }

  if (isLoadingMeRequest) {
    return AuthenticationStatus.Loading
  }

  if (!accountReady) {
    return AuthenticationStatus.Incomplete
  }

  if (!isAccountProvisioningReady) {
    return AuthenticationStatus.AccountProvisioning
  }

  return user ? AuthenticationStatus.Success : AuthenticationStatus.Loading
}

export default useAuthenticationStatus
